import { Button } from '@grofers/react';
import React from 'react';
import { useForm } from 'react-hook-form';
import { useUpdateCustomerEmail } from '../apis';
import { toNumber } from 'lodash-es';
import { grey } from 'sushiweb/tokens/color';
import Spinner from 'sushiweb/Spinner/Spinner';
import { Star } from '../../../UiKit/Star/Star';

const UpdateCXEmail = () => {
  const form = useForm();
  const { register, handleSubmit, formState, reset } = form;
  const { errors } = formState;
  const { isLoading, mutate } = useUpdateCustomerEmail({
    onSuccess: () => {
      reset();
    },
  });

  const onSubmit = (data) => {
    const dataToSubmit = {
      user_id: toNumber(data.user_id),
      email_id: data.email_id,
    };
    mutate(dataToSubmit);
  };

  return (
    <form
      className='tw-w-full tw-flex tw-flex-col tw-h-max tw-gap-10 tw-bg-white tw-p-8 tw-rounded-2xl'
      onSubmit={handleSubmit(onSubmit)}
    >
      <div className='tw-flex tw-w-full tw-h-max tw-gap-5'>
        <div className='tw-flex tw-flex-col tw-h-max tw-gap-5 tw-flex-1'>
          <div className='tw-w-full tw-color-[#1F1F1F] tw-font-bold tw-text-500'>
            User ID <Star icon='*' />
          </div>
          <div className='tw-flex tw-flex-col tw-w-full'>
            <input
              id='UserId'
              name='user_id'
              type={'number'}
              placeholder='Please enter user id'
              className={`tw-appearance-none tw-px-5 tw-py-2 tw-h-16 tw-rounded-lg tw-outline-0  focus:tw-border-none focus:tw-ring-[1.5px]
              ${
                errors?.user_id?.message
                  ? 'focus:tw-ring-[#BF2938] focus:tw-border-RED'
                  : 'focus:tw-ring-green-500 focus:tw-border-green-500'
              }  tw-border tw-border-solid tw-border-[#cfcfcf] tw-mr-6`}
              autoComplete='off'
              {...register('user_id', {
                pattern: {
                  value: /^[0-9]+$/,
                  message: 'Customer Id must be a number',
                },
                required: { value: true, message: 'User Id is Required' },
              })}
            />
            <p className='tw-mt-1 tw-text-[#BF2938]'>
              {errors?.user_id?.message}
            </p>
          </div>
        </div>
        <div className='tw-flex tw-flex-col tw-h-max tw-gap-5 tw-flex-1'>
          <div className='tw-w-full tw-color-[#1F1F1F] tw-font-bold tw-text-500'>
            Email ID <Star icon='*' />
          </div>
          <div className='tw-flex tw-flex-col tw-w-full'>
            <input
              id='email'
              name='email_id'
              placeholder='Please enter email id'
              className={`tw-appearance-none tw-px-5 tw-py-2 tw-h-16 tw-rounded-lg tw-outline-0  focus:tw-border-none focus:tw-ring-[1.5px] tw-w-full
              ${
                errors.email_id
                  ? 'focus:tw-ring-[#BF2938] focus:tw-border-RED'
                  : 'focus:tw-ring-green-500 focus:tw-border-green-500'
              }  tw-border tw-border-solid tw-border-[#cfcfcf] tw-mr-6`}
              {...register('email_id', {
                pattern: {
                  value: /\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z|a-z]{2,}\b/,
                  message: 'Invalid email id',
                },
                required: { value: true, message: 'Email Id is Required' },
              })}
              autoComplete='off'
              data-dd-privacy='mask'
            />
            <p className='tw-mt-1 tw-text-[#BF2938]'>
              {errors?.email_id?.message}
            </p>
          </div>
        </div>
      </div>
      <Button variant={'fill'} className='tw-h-16 tw-w-28'>
        {isLoading ? <Spinner size='small' color={`${grey.z300}`} /> : 'Submit'}
      </Button>
    </form>
  );
};

export default UpdateCXEmail;
